// extracted by mini-css-extract-plugin
export var active = "lcSidebarCategory-module--active--a5025";
export var arrowIcon = "lcSidebarCategory-module--arrowIcon--5a1e0";
export var category = "lcSidebarCategory-module--category--9735f";
export var head = "lcSidebarCategory-module--head--2d3a2";
export var items = "lcSidebarCategory-module--items--2d6f0";
export var open = "lcSidebarCategory-module--open--f0b0b";
export var selfActive = "lcSidebarCategory-module--selfActive--8d868";
export var title = "lcSidebarCategory-module--title--5f395";